import { configureStore } from '@reduxjs/toolkit';
import quickPayReducer from '@voucherForm/store/reducers/quickPay';
export const storeOptions = {
    reducer: {
        quickPay: quickPayReducer,
    },
};
const store = configureStore(storeOptions);
export default store;
